<template>
    <div>
          <el-row>
          <el-col :lg="22" :offset="2">
              使用禮卷清單:
              <el-table
                  :data="coupon.slice((currentPage-1)*pagesize,currentPage*pagesize)"
                  style="width: 100%"
                  empty-text="暫無數據"
                  >
                  <el-table-column label="日期" prop="useday">
                      
                  </el-table-column>
                  <el-table-column
                      prop="Name"
                      label="名稱"
                      >
                  </el-table-column>
                  <el-table-column label="類別">
                      <template slot-scope="scope" >
                        <el-tag type="info" effect="dark"> {{scope.row.type == 1 ? '公司禮卷':'通路禮卷'}}</el-tag>
                      </template>
                  </el-table-column>
                  <el-table-column label="店櫃" prop="shop_name" ></el-table-column>
                  
              </el-table>
                    <el-pagination
        background
        layout="prev, pager, next"
        :total="total1"
        @current-change="current_change"
        >
      </el-pagination>
          </el-col>
      </el-row>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
     name: 'coupon',
        props: {
            memberKey: String
        },
        data() {
            return {
                coupon: [],
                
                          total1: 0,
                 currentPage:1,
                pagesize: 10,
            }
        },
         computed: mapGetters(["getMemberCoupon"]),
        methods: {
            ...mapActions(["fetchMemberCoupon"]),
            async fetch(){
                  const data =await {_key: this.memberKey}
              await this.$store.dispatch('fetchMemberCoupon', data)
              this.coupon = this.getMemberCoupon
              this.total1 = this.coupon.length
             
            },
                current_change: function (currentPage) {
                this.currentPage = currentPage;
            }
        },
        mounted() {
            this.fetch()
        },
}
</script>